import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {EquipmentSelect} from '../equipment-select.namespace';
import ViewStatus = EquipmentSelect.ViewStatus;
import {EquipmentEnums, EquipmentInterfaces} from '@namespaces/equipment.namespace';

@Injectable()
export class EquipmentSelectControlService {
    private _viewStatus$ = new BehaviorSubject<ViewStatus>(ViewStatus.search);
    private _selectedEquipmentId$ = new BehaviorSubject<number>(null);
    private _selectedEquipment$ = new BehaviorSubject<EquipmentInterfaces.Model>(null);
    private _canCreateOwn$ = new BehaviorSubject<boolean>(false);

    public viewStatus$ = this._viewStatus$.asObservable().pipe(
        distinctUntilChanged()
    );

    public selectedEquipmentId$ = this._selectedEquipmentId$.asObservable().pipe(
        distinctUntilChanged()
    );

    public selectedEquipment$ = this._selectedEquipment$.asObservable().pipe(
        distinctUntilChanged()
    );

    public canCreateOwn$ = this._canCreateOwn$.asObservable().pipe(
        distinctUntilChanged()
    );

    setViewStatus(status: ViewStatus) {
        this._viewStatus$.next(status);
    }

    setSelectedEquipmentId(id: number) {
        this._selectedEquipmentId$.next(id);
    }

    setSelectedEquipment(model: EquipmentInterfaces.Model) {
        this._selectedEquipment$.next(model);
    }

    setCanCreateOwn(can: boolean) {
        this._canCreateOwn$.next(can);
    }

    /**
     * Сбросить все значения сервиса на дефолтные.
     * Применяется в том случае, если сервис используется без повтроной инициализации
     * при переходах между компонентеми для того,
     * чтобы новые компоненты не использовали старые значения
     */
    reset() {
        this._viewStatus$.next(ViewStatus.search);
        this._selectedEquipmentId$.next(null);
        this._selectedEquipment$.next(null);
        this._canCreateOwn$.next(false);
    }
}
